export default "__VITE_ASSET__D$3qEX4P__"